









import ApiClient from '@/js/api.js'
import store from '@/store'
import Pankuzu from '@/views/molecules/Pankuzu.vue'
import ManageBase from '@/views/organisms/ManageBase.vue'
import Title from '@/views/atoms/Title.vue'
import SendConfirmForm from '@/views/templates/SendConfirmForm.vue'


export default
    name: 'UserConfirm'
    components: {
        Pankuzu
        ManageBase
        Title
        SendConfirmForm
    }
    data: () =>
        loginCheck: false
        url: '/user/append'

    beforeCreate: () ->
        window.scrollTo(0, 0)

    created: () ->
        @$emit('set_color', true)
        api = new ApiClient()
        @loginCheck = await store.getters.isLogin
        if @loginCheck
            @url = '/user/edit'

    methods: {
        go_back: (e) ->
            @$router.push @url
    }
